import { IBaseSectionType } from './types';
import styles from './invoiceform.module.scss';
import { getTotalAmountDetails } from './helpers';
import { fmPrice } from '~/utils/amount';

const SummarySection = ({ formData }: IBaseSectionType) => {
  const { subTotal, discount, tax, shipping, totalAmount } = getTotalAmountDetails(formData);
  const { currency } = formData;

  return (
    <div className={styles.summaryWrapper}>
      <div className={styles.summaryContainer}>
        <div className={styles.summaryRow}>
          <p className={styles.darkSumLabel}>Sub Total:</p>
          <p className={styles.darkSumValue}>{fmPrice(currency, subTotal)}</p>
        </div>

        {discount ? (
          <div className={styles.summaryRow}>
            <p className={styles.sumLabel}>Discount:</p>
            <p className={styles.sumValue}>-{fmPrice(currency, discount)}</p>
          </div>
        ) : null}

        {tax ? (
          <div className={styles.summaryRow}>
            <p className={styles.sumLabel}>Tax:</p>
            <p className={styles.sumValue}>{fmPrice(currency, tax)}</p>
          </div>
        ) : null}

        {shipping ? (
          <div className={styles.summaryRow}>
            <p className={styles.sumLabel}>Shipping:</p>
            <p className={styles.sumValue}>{fmPrice(currency, shipping)}</p>
          </div>
        ) : null}

        <div className={styles.summaryTotalAmtRow}>
          <p className={styles.greenSumLabel}>TOTAL AMOUNT:</p>
          <p className={styles.greenSumValue}>{fmPrice(currency, totalAmount)}</p>
        </div>
      </div>
    </div>
  );
};

export default SummarySection;
